<template>
  <div class="footer-box">
    <myHeader class="my-header"></myHeader>

    <div class="page-container">
      <div class="module-title">品牌背景</div>

      <div>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;伍斋良田宿迁伍斋良田有限公司创立于2017年12月，公司位于<strong>中国・沭阳・南湖街道</strong>，是一家致力于粽子月饼等糕点类食品的食品生产和销售企业。公司有完善的食品生产车间，具备食品生产许可资质。公司在传承民族饮食文化的基础上不断创新，也在不断研发本土特色食品。
        </div>
        <div>一：粽子</div>
        <div>二：月饼</div>
        <div>三：苏北葱油饼</div>
        <div>四：蛋黄焗朝牌</div>
      </div>

      <div class="module-title">品牌渊源：五谷为斋，良田为心</div>
      <div>
        <div>
          清光绪二十四年（1898年），江南古镇有一家名为“伍斋堂”的点心铺。铺主伍伯年老先生，一生遵循“不时不食”的古训。他发现，许多人家每逢端午中秋，总为寻一口地道粽月而犯愁——市面上的糕点要么甜腻失本味，要么用料敷衍失匠心。<br />
          伍老遂立下规矩：<strong
            >“宁可五日只做一炉糕，不抢一时赶万单。”</strong
          >
          他将铺中五间斋房分别用于浸泡、研磨、制馅、包裹、蒸焙，每道工序皆守时辰。因所选糯米、赤豆、莲蓉皆出自自家与乡邻共耕的百亩良田，镇上的孩童便编了童谣：<strong
            >“伍斋良田，五谷团圆。”</strong
          ><br />
          百年流转，伍氏后人重拾祖业，于2017年正式创立“伍斋良田”品牌。他们将老铺的木质牌匾从仓库请出，那块刻着“良田在心，五味得真”的旧匾，成了品牌的第一条铁律。
        </div>
      </div>

      <div class="module-title">核心理念：用时间，兑换本味</div>

      <div>
        <div>
          <strong>“伍斋”</strong>
          是态度——代表糕点制作的<strong>五重工序</strong>（选、浸、研、裹、蒸）与<strong>五种坚守</strong>（真材、手工、减糖、无添、应季）。<br />

          <strong>选：</strong> 东北黑土糯米，一年一季，只为那一口软糯弹牙。
          <br />
          <strong>浸：</strong>山泉水浸泡足时，让米粒吸饱水分，蒸后粒粒透亮。
          <br />
          <strong>研：</strong>
          广西荔浦芋头、高邮红心咸蛋、湘莲……每样馅料手工研磨，保留颗粒感。<br />
          <strong>裹：</strong>
          保留古法手工包裹，不用机器挤压，保留食材呼吸的空间。<br />
          <strong>蒸：</strong> 竹笼慢蒸，火候随节气调整，让香气层层渗透。<br />
          <strong>“良田”</strong>
          是源头——品牌在全国签约了多处生态种植基地。从东北五常的糯米田，到湖南湘潭的寸三莲田，再到云南玫瑰谷的食用玫瑰园。每一块“良田”都有专属编号，消费者扫码即可查看当年粽叶长势、糯米收割时的天气。
        </div>
      </div>

      <div class="module-title">产品哲学：以两节，敬四时</div>

      <div>
        <div>
          伍斋良田致力于深耕端午与中秋这两个中国人的“时间坐标”。<br />
          <strong>端午·枕粽系列：</strong><br />
          遵循“三枕三不枕”老规矩——枕的是当季新采的黄山箬叶、浸润过的圆糯、肥瘦相间的土猪腿肉；不枕的是隔年陈米、香精色素、机器压制的紧实死板。其招牌“双黄鲜肉枕粽”切开，两头各卧一颗咸蛋黄，油润流沙，被食客称为“粽中黄金分割”。<br />
          <strong>中秋·本味月饼系列：</strong><br />
          拒绝“过度包装下的甜腻”，主打“减糖30%却不减风味”。招牌“伍仁金腿月饼”，五仁必须粒粒整颗入馅，金华火腿手工撕成细丝，咬下去是坚果的酥脆与火腿的咸鲜，而非工业化的齁甜。另一款“流心奶黄”则用海鸭蛋蛋黄现烤流沙，强调“月心即本心”。<br />
          <strong>品牌Slogan（标语）： “伍斋守古法，良田种时间。”</strong>
        </div>
      </div>

      <div class="module-title">品牌运营方案</div>
      <div>
        <div>
          1.产品创新：不断研发新的产品，满足消费者日益增长的需求。同时，对现有产品进行升级和改进，提高产品的品质和竞争力。<br />
          2.客户服务：建立完善的客户服务体系，及时回复用户的咨询和投诉，提高用户满意度。<br />
          3.数据分析：通过对销售数据、用户行为数据等进行分析，了解用户需求和市场趋势，为品牌的发展提供决策依据。<br />
          4.品牌建设：加强品牌建设，提升品牌知名度和美誉度。通过广告投放、公关活动等方式，树立品牌的良好形象。<br />
        </div>
      </div>
      <div class="module-title">货品价格</div>

      <div>
        我们秉承:货真价实,不去虚高产品的价格,保持正常的零售价格,真材实料添加,销售亲民价格，以便品牌走的更长远。长久才是正确的经营思路。
      </div>
    </div>

    <!-- <div>
            <el-anchor :offset="70">
                <el-anchor-link :href="`#${locale['basic-usage']}`">
                    {{ locale['Basic Usage'] }}
                </el-anchor-link>
            </el-anchor>
        </div> -->

    <div class="back-box" @click="backTop">
      <div class="iconfont icon-xiangshang1"></div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import myFooter from "../components/myFooter.vue";
import myHeader from "../components/myHeader.vue";

export default {
  name: "LoginPage",
  components: {
    myFooter,
    myHeader,
  },
  data() {
    return {};
  },
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped lang="less">
.el-checkbox__input > .el-checkbox__inner {
  display: none;
}

.page-container {
  margin: 126px 0 30px 0;
  padding: 0 20%;
  background-color: white;
  line-height: 30px;

  .module-title {
    font-size: 20px;
    font-weight: 700;
    line-height: 50px;
  }
}

.back-box {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 5px;
  background-color: black;
  color: white;
}

@media (max-width: 768px) {
  .page-container {
    margin-top: 126px;
    padding: 0 8%;
    background-color: white;
  }
}
</style>
